import { Typography } from '@cobliteam/ui/components';
import type React from 'react';

interface TimeDisplayProps {
  startTime: string;
  endTime: string;
  timeRange: string;
}

const TimeDisplay: React.FC<TimeDisplayProps> = ({ startTime, endTime, timeRange }) => {
  return (
    <div className='-mx-1 mb-4 flex items-center justify-between'>
      <div className='flex items-center gap-2'>
        <div className='size-3 rounded-full bg-primary' />
        <Typography variant='text-sm-medium' color='primary'>
          {startTime}
        </Typography>
      </div>
      <Typography variant='caption-default' color='secondary'>
        {timeRange}
      </Typography>
      <div className='flex items-center gap-2'>
        <Typography variant='text-sm-medium' color='primary'>
          {endTime}
        </Typography>
        <div className='size-3 rounded-full bg-primary' />
      </div>
    </div>
  );
};

export default TimeDisplay;
